<template>
  <div class="terms-page">
    <div class="container">
      <h1>Условия использования</h1>
      <div class="content">
        <p>Здесь будет размещена информация об условиях использования сервиса CTmap.</p>
        <!-- Add your terms content here -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsView'
}
</script>

<style scoped>
.terms-page {
  padding: 40px 20px;
  min-height: 60vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  font-family: 'Raleway', sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  color: #F0F0F0;
  margin-bottom: 2rem;
}

.content {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: #F0F0F0;
}

@media (max-width: 768px) {
  .terms-page {
    padding: 20px 15px;
  }
  
  h1 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
}
</style>
